
import React from 'react';
import { sprintf } from "sprintf-js";
import {Times} from "./utils";

const VIMEO_URL = "https://player.vimeo.com/video";
const ARGS = "dnt=1&amp;app_id=122963&amp;h=aeebb9d5f2&allow=autoplay";
const AR = 1.7777;

const VimeoPlayer = props => {

  const style = {
    ...props.style,
  }

  if (!style.height && style.width.substr(-3) === "rem") {
    const wid = parseFloat(style.width.substr(0, style.width.length - 3));
    style.height = sprintf("%.2frem", wid / AR);
  }
  let url = VIMEO_URL + "/" + props.video_id + "?" + ARGS;
  if (props.autoplay) {
    url += "&autoplay=1";
  }

  return (
    <iframe
      src={url}
      style={style}
      frameBorder={0}
      allow="autoplay; fullscreen; picture-in-picture"
      title={"CleverAlpha Video"}
      allowFullScreen=""/>
  )
}

const VimeoPopup = props => {

  const card_style = {
    width: props.width,
    border: "1px solid black",
    backgroundColor: "#FFF",
  }
  const video_style = {
    width: "640px",
    height: "360px",
  }
  const header_style = {
    direction: "rtl",
    backgroundColor: "#FFF",
  }
  const header = (
    <header className="modal-card-head" style={header_style}>
      <span onClick={props.onDismiss} style={{cursor: "pointer"}}>
        <Times style={{fontSize: "2rem"}}/>
      </span>
    </header>);

  return (
    <div className={"modal is-active"}>
      <div className="modal-card" style={card_style}>
        { !props.no_header && header }
        <VimeoPlayer
          style={video_style}
          autoplay={props.autoplay}
          video_id={props.video_id}/>
        { props.footer }
      </div>
    </div>
  )
}

export { VimeoPlayer, VimeoPopup };
